// Libs
import React from 'react'
import { NavLink } from 'react-router-dom'

// CSS
import './styles.scss'

const HeaderLink = ({ border, padding, mobile, children, to, ...props }) => {
  return (
    <NavLink
      className={mobile ? "header-link header-link--mobile" : "header-link"}
      activeClassName="header-link__link--active"
      to={to}
      {...props}>
      <span className="header-link__link">{children}</span>
    </NavLink>
  )
}

export default HeaderLink
